export default {
	text:
		'Your browser is out of date or not supported. \nSome features of the site may not work correctly',
	btn: 'Start using',
}
